import { ScheduleType } from '../common/types/calendar'
import { Color } from '../common/types/color'

export type Row = {
  process_id: string
  equipment_id: string
  start_date: string
  end_date: string
  color_code: string
  process_name: string
}

export const convertSchedules = (rows: Row[]): ScheduleType[] => {
  return rows.map((row: Row) => {
    return {
      color: row.color_code as Color,
      column_id: row.equipment_id,
      end_date: new Date(row.end_date),
      id: row.process_id,
      name: row.process_name,
      start_date: new Date(row.start_date),
    }
  })
}
